var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTicketClip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    viewBox: "0 0 356 620",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ticketClip",
    clipPathUnits: "objectBoundingBox",
    transform: "scale(0.002792, 0.001595)"
  }, /*#__PURE__*/React.createElement("path", {
    "transform-box": "fill-box",
    "transform-origin": "center",
    d: "M211.621 1C211.621 20.3645 195.899 36.0643 176.508 36.0643C157.116 36.0643 141.398 20.3645 141.398 1H1V618.319H141.398C141.398 598.948 157.123 583.245 176.521 583.245C195.919 583.245 211.644 598.948 211.644 618.319H354.322V1H211.624H211.621Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketClip);
export default __webpack_public_path__ + "static/media/ticket-clip.6c51e602e71f6b324da74aa742086d9d.svg";
export { ForwardRef as ReactComponent };